<template>
    <div>
        <hr v-if="index > 0" class="special-line-no-margin mt-16 btn-hide" />
        <div class="location-box mt-56">

            <router-link class="text-decoration-none" :to="{name: 'Protocolo', params: { id: searchResult.idprotocolo}}">
                <h5 class="custom-h5 secondary-color">
                    {{ searchResult.subempresa !== searchResult.empresa ?
                    (searchResult.empresa + ' - ' +  searchResult.subempresa) :
                    searchResult.empresa }}</h5>
            </router-link>

            <div class="location mt-24">

                <img src="assets/images/location_blue.png" class="location-icon mr-1" />
                <div class="location box">
                    <a class="custom-p block sm primary-color text-decoration-none" target="_new"
                       :href="'https://www.google.com/maps/dir/?api=1&origin=' + userCurrentLocation + '&destination=' + encodedMorada">
                        {{ searchResult.morada }}<br/>
                        {{ searchResult.codigo_postal }} {{ searchResult.localidade }} - {{ searchResult.distrito }}
                    </a>
                </div>

                <div class="btn-hide">
                    <h6 class="custom-h6 discount">Desconto</h6>
                    <span class="custom-p gray-color discount-percent">{{ searchResult.desconto }}</span>
                </div>
            </div>

            <div class="location mt-24">
                <img src="assets/images/blue_phone.png" class="location-icon mr-1" />
                <div class="location box">
                <span class="custom-p block sm primary-color text-decoration-none">
                    {{ searchResult.telefone === null ? "&nbsp;" : searchResult.telefone }}
                </span>
                </div>
            </div>

        </div>

        <div class="btn-hide-mobile margin-discount mt-24">
            <h6 class="custom-h6">Desconto</h6>
            <span class="custom-p gray-color">{{ searchResult.desconto }}</span>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        props: ['index', 'searchResult'],

        computed: {
            ...mapGetters('dirpesquisador',
                {
                    userCurrentLocation: 'getUserCurrentLocation',
                },
            ),
            encodedMorada() {
                const searchResult = this.searchResult;
                return searchResult.morada + ' ' + searchResult.codigo_postal + ' ' + searchResult.localidade;
            }
        },
    };
</script>